import { render, staticRenderFns } from "./SendButton.vue?vue&type=template&id=ea410af2&scoped=true&"
import script from "./SendButton.vue?vue&type=script&lang=js&"
export * from "./SendButton.vue?vue&type=script&lang=js&"
import style0 from "./SendButton.vue?vue&type=style&index=0&id=ea410af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea410af2",
  null
  
)

export default component.exports